module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('title', [_vm._v("The Man In The Mirror: Solving The 24 Problems Men Face")]), _c('link', {
    attrs: {
      "href": "css/default.css",
      "rel": "stylesheet",
      "type": "text/css"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "ct2",
    attrs: {
      "id": "p0044-01-0"
    }
  }, [_c('a', {
    attrs: {
      "id": "page44"
    }
  }), _c('a', {
    attrs: {
      "href": "#/contents#p0013-Anch-6"
    }
  }, [_vm._v("CHAPTER 2 ")])]), _vm._v(" "), _c('p', {
    staticClass: "ct1"
  }, [_c('a', {
    attrs: {
      "href": "#/contents#p0013-Anch-6"
    }
  }, [_vm._v("LEADING AN UNEXAMINED LIFE")])]), _vm._v(" "), _c('p', {
    staticClass: "txcc",
    attrs: {
      "id": "p0044-02-1"
    }
  }, [_vm._v("The life which is unexamined is not worth living.")]), _vm._v(" "), _c('p', {
    staticClass: "txcc",
    attrs: {
      "id": "p0044-02-2"
    }
  }, [_c('b', [_vm._v("Socrates, quoted by Plato in "), _c('i', [_vm._v("Apology ")])]), _c('br'), _c('br')]), _vm._v(" "), _c('p', {
    staticClass: "txcc",
    attrs: {
      "id": "p0044-03-3"
    }
  }, [_vm._v("Let us examine our ways and test them, and let us return to the L"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ORD")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "txcc",
    attrs: {
      "id": "p0044-04-5"
    }
  }, [_c('b', [_vm._v("Lamentations 3:40")]), _c('br'), _c('br')]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "p0044-05-6"
    }
  }, [_c('span', {
    staticClass: "dcap"
  }, [_c('b', [_vm._v("I")])]), _vm._v(" used to watch "), _c('i', [_vm._v("Dempsey and Makepeace")]), _vm._v(", a British TV show that was on for a couple of years in the 1980s.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0044-06-9"
    }
  }, [_vm._v("He was Dempsey — a tough New York cop. After a reliable police informer reported that the mob had placed a contract on Dempsey’s life, his boss sent Dempsey — a gruff, head-busting maverick — to London for safekeeping.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0044-07-11"
    }
  }, [_vm._v("She was Makepeace — a very feminine, very British, very proper English policewoman. They become partners. Together they played the lead roles in what turned out to be a classic English cops-and-robbers program.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0044-08-13"
    }
  }, [_vm._v("On the lead-in at the top of each week’s show, they ran away from burning cars that exploded in the background. They dove to the pavement so they wouldn’t be sprayed by machine-gun fire. They rolled across the ground and returned gunfire at the bad guys. You knew an hour of nonstop action was on the way! Then the screen suddenly quieted, and the camera zoomed in on a close-up of Dempsey’s knotty face. He glared straight into the camera lens for what seemed like a long time. And then, very matter-of-factly, he summarized his view of the world: “Life is hard, and then you die.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0045-02-2"
    }
  }, [_c('a', {
    attrs: {
      "id": "page45"
    }
  }, [_c('i', [_vm._v("Dissolve to a commercial.")])])]), _c('a', {
    attrs: {
      "id": "page45"
    }
  }, [_c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0045-03-4"
    }
  }, [_vm._v("You didn’t get the impression Dempsey represented the profound intellectual sort, but there is a certain ring of truth to what he said. Dempsey took life one episode at a time, never giving a thought to what tomorrow might bring.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0045-04-7"
    }
  }, [_vm._v("A lot of us are like Dempsey.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0045-05-9"
    }
  }, [_vm._v("There comes a day, though, when we each want the "), _c('i', [_vm._v("real")]), _vm._v(" answers to the questions Dempsey raised: “Why is life so hard?” and “What happens when I die?”")]), _vm._v(" "), _c('p', {
    staticClass: "h2",
    attrs: {
      "id": "p0045-06-11"
    }
  }, [_vm._v("THE PROBLEM ")]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "p0045-07-12"
    }
  }, [_vm._v("When we progress along the trajectory we set for ourselves, we don’t give much thought to the "), _c('i', [_vm._v("why")]), _vm._v(" questions of life. But when we hit the target and are still not satisfied, the questions start to come. “Who am I? Why do I exist? Is this all there is? If I’m so successful, why do I feel so empty?”")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0045-08-14"
    }
  }, [_vm._v("And if we "), _c('i', [_vm._v("don’t")]), _vm._v(" hit our target, the list of questions grows even longer. “Why me, God? If You love me, where are You when I need You? Why won’t You bless me? How could this happen to me?” Our hurt feelings slowly give way to anger and bitterness, or fear and guilt, or some of each.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0045-09-16"
    }
  }, [_vm._v("After all is considered, the number one shortcoming of man is that "), _c('i', [_vm._v("we tend to lead unexamined lives")]), _vm._v(". "), _c('i', [_vm._v("Most men have not carefully ")]), _c('i', [_vm._v("chiseled their worldview by a personal search for truth and obedience ")]), _c('i', [_vm._v("to God")]), _vm._v(".")])]), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0046-01-0"
    }
  }, [_c('a', {
    attrs: {
      "id": "page45"
    }
  }), _c('a', {
    attrs: {
      "id": "page46"
    }
  }, [_vm._v("Instead, we rush from task to busy task, but we don’t call enough time-outs to reflect on life’s larger meaning and purpose. Rather, we live myopically from day to day to day; we live under the tyranny of today’s problems. Our lives, like Dempsey’s, are consumed in action as we react to the seemingly endless menu of options that vie for our attention, time, and money. But as Gandhi said, “There is more to life than increasing its speed.”")])]), _c('a', {
    attrs: {
      "id": "page46"
    }
  }, [_c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0046-02-2"
    }
  }, [_vm._v("Spiritually, too many of us are just “playing church” — just going through the motions. We show up for worship services, but the message we come away with doesn’t do for us what it does for some of the other men. We don’t know exactly why, and before we spend much time thinking about it, our minds wander to the work problems chewing at our gut. We speed off to the next busy task, and by Monday afternoon, the memory of Sunday is as distant as the memory of last year’s vacation.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0046-03-4"
    }
  }, [_vm._v("As a lawyer or electrician is no better than the effort he puts into keeping up with his profession, so is the Christian no better than the effort he puts into self-examination of life’s big questions.")]), _vm._v(" "), _c('p', {
    staticClass: "h2",
    attrs: {
      "id": "p0046-04-6"
    }
  }, [_vm._v("NOT EVERYONE THINKS LIKE I DO ")]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "p0046-05-7"
    }
  }, [_vm._v("A friend astonished me with a comment at lunch one day. He was telling me his views on abortion. He was foreign-born, with a sense of history, and I had always admired his business skill.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0046-06-9"
    }
  }, [_vm._v("He suggested it was better to kill the unborn than to allow them to be born unwanted into a life of suffering. He did not argue that the unborn are not human beings. Rather, since they would be neglected and possibly abused, he reasoned the unwanted are mercifully spared when terminated before birth. Of all the reasons I’ve heard for abortion, this one stands alone as the most patently absurd. This friend — wealthy and influential — was making important commercial decisions shaping the life of our community.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0046-07-12"
    }
  }, [_c('i', [_vm._v("Why do men think the things they think, say the things they say, and ")]), _vm._v(" "), _c('i', [_vm._v("do the things they do?")]), _vm._v(" Each of us has a worldview. For most of us, our worldview results more from where we were born, who our parents were, and what schools we attended than a careful examination of issues. Yet our worldview influences every thought we have, every word we speak, and every action we take.")])]), _c('p', {
    staticClass: "h2",
    attrs: {
      "id": "p0047-02-2"
    }
  }, [_c('a', {
    attrs: {
      "id": "page46"
    }
  }), _c('a', {
    attrs: {
      "id": "page47"
    }
  }, [_vm._v("TWO WORLDVIEWS ")])]), _c('a', {
    attrs: {
      "id": "page47"
    }
  }, [_c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "p0047-03-3"
    }
  }, [_vm._v("As we grow and mature, our worldview develops from our many experiences and relationships. There are two predominant worldviews in America today. One view, the "), _c('i', [_vm._v("secular worldview")]), _vm._v(", believes man is the central figure in shaping events. The second view, the "), _c('i', [_vm._v("Christian worldview")]), _vm._v(", believes God is sovereign and active in everyday life.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0047-04-5"
    }
  }, [_vm._v("The secularist believes man is intrinsically good, masters his own fate, determines on his own the boundaries of his achievements and knowledge, and is unconstrained by moral standards — apart from those he chooses at his sole discretion.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0047-05-7"
    }
  }, [_vm._v("The Christian, on the other hand, believes an all-powerful God created the heavens and the earth. This living, omnipotent God possesses all knowledge, and because of His great love for us, He established absolute moral standards for our protection. He is holy, loving, and personal.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0047-06-9"
    }
  }, [_vm._v("Often confused about the differences between these two worldviews, Christian men frequently apply the wrong set of principles to their problems. We seem to have a fragmented understanding of how to live as Christian men.")])]), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0047-07-11"
    }
  }, [_c('a', {
    attrs: {
      "id": "page47"
    }
  }, [_vm._v("In today’s world, Christians have seen things in bits and pieces instead of in totals. We have sounded alarms over the breakdown of the family, pornography, gun violence, racism, poverty, and abortion. But as Dr. Francis Schaeffer pointed out, we “have not seen this as a totality — each thing being a part, a symptom, of a much larger problem.”")]), _c('span', {
    attrs: {
      "href": "#/chapter40#nts_5",
      "id": "not_5",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', [_vm._v("5")])])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0047-08-12"
    }
  }, [_vm._v("This “larger problem” is the basic shift in values mentioned in "), _c('a', {
    attrs: {
      "href": "#/chapter7#p0027-01-0"
    }
  }, [_vm._v("chapter 1")]), _vm._v(". It’s a fundamental change in how we view life and the world as a whole. We have moved away from traditional Judeo-Christian values toward a worldview that lets us self-select values based on whether they serve our self-interests. Like a child loose in a candy store, "), _c('i', [_vm._v("we ")]), _vm._v("pick our values, "), _c('i', [_vm._v("we")]), _vm._v(" determine our own fate, "), _c('i', [_vm._v("we ")]), _vm._v("captain our own ship.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0048-02-2"
    }
  }, [_c('a', {
    attrs: {
      "id": "page48"
    }
  }, [_vm._v("These two worldviews, secular and Christian, are on a collision course. They inevitably produce opposite results. To understand the differences between the two is the key first step to resolving the questions of the unexamined life.")])]), _c('a', {
    attrs: {
      "id": "page48"
    }
  }, [_c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0048-03-4"
    }
  }, [_vm._v("We often don’t even "), _c('i', [_vm._v("see")]), _vm._v(" these dramatic differences. I’m sure you have seen a daring circus performer riding two horses at the same time. He has one foot firmly planted on the back of each horse. He can do this because they are so close together. If the two horses begin to move apart from each other, though, the performer must pick one or the other to ride.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0048-04-6"
    }
  }, [_vm._v("So it is in our spiritual journeys. At first these two worldviews don’t seem that far apart. Unless we carefully examine our lives, we tend to see the Christian worldview and the secular worldview close together, like our two circus horses. However, when we begin to take a closer look, we start to see unmistakable contrasts.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0048-05-8"
    }
  }, [_vm._v("We begin to see how dramatically different — even totally opposite — they are. As they come into sharper focus, they move farther and farther apart, and we eventually reach a point, like the daring circus performer, at which we must choose one or the other.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0048-05-9"
    }
  }, [_vm._v("The choice between a Christian worldview and a secular worldview is a choice between God’s race and the rat race.")])]), _c('p', {
    staticClass: "h2",
    attrs: {
      "id": "p0048-06-11"
    }
  }, [_c('a', {
    attrs: {
      "id": "page48"
    }
  }), _c('a', {
    attrs: {
      "id": "page49"
    }
  }, [_vm._v("THE RESULTS OF LEADING AN UNEXAMINED LIFE ")])]), _c('a', {
    attrs: {
      "id": "page49"
    }
  }, [_c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "p0048-07-12"
    }
  }, [_vm._v("John and Betty started out like most Christians. For seven years I watched them struggle with lifestyle and worldview issues. They sincerely wanted the peace and contentment that comes from knowing Christ personally. Yet they experienced a constant tension because of their material appetites. Betty, in particular, always wanted more.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0049-P-1"
    }
  }, [_vm._v("They lived in a comfortable home, but like so many of us, they clutched the hope of buying their dream house. John knew the payments weren’t manageable, but Betty seemed so anxious to take the leap. Eventually they plunged in and bought a real showplace.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0049-02-2"
    }
  }, [_vm._v("John just couldn’t seem to satisfy Betty’s appetite for possessions. He worked hard enough, but Betty honestly believed he was unambitious. When John worked on Christian tasks, Betty felt he was copping out on his responsibility to work and save for the family they talked of starting.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0049-03-5"
    }
  }, [_vm._v("Two years later, Betty went home during the summer to visit her parents for a few weeks. One day Betty phoned home.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0049-04-7"
    }
  }, [_vm._v("“I’ve taken a job,” she said simply.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0049-05-9"
    }
  }, [_vm._v("“What does that mean?” John managed to ask, with a lump in his throat.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0049-06-11"
    }
  }, [_vm._v("Betty didn’t respond in terms of their relationship, but spoke only of her ambition to earn more money. They eventually filed for divorce, and their lawyers leveled off at each other. They lost the house they bought to the mortgage company.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0049-07-13"
    }
  }, [_vm._v("How can a Christian couple go so far astray? The secular worldview competes directly with the Christian worldview. Since Christians are in a minority, we are often proselytized by the majority message of consumerism and materialism that is trying to convert us to a secular lifestyle. That’s right — the disciples of the other worldview work just as hard as Christians do to make converts! ")])]), _c('p', {
    staticClass: "h2",
    attrs: {
      "id": "p0049-08-15"
    }
  }, [_c('a', {
    attrs: {
      "id": "page49"
    }
  }), _c('a', {
    attrs: {
      "id": "page50"
    }
  }, [_vm._v("CHRISTIANS IN CAPTIVITY ")])]), _c('a', {
    attrs: {
      "id": "page50"
    }
  }, [_c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "p0049-09-16"
    }
  }, [_vm._v("Yes, these two predominant worldviews exist, but how many of us have drawn a sharp contrast between the two? How many of us have carefully chiseled ours by a search for truth? Or is our worldview more the product of our environment and circumstances?")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0050-02-2"
    }
  }, [_vm._v("Colossians 2:8 tells us, “See to it that no one takes you captive through hollow and deceptive philosophy, which depends on human tradition and the elemental spiritual forces of this world rather than on Christ.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0050-03-4"
    }
  }, [_vm._v("The secularists have been doing a much better job of influencing our culture than we Christians. School prayer was made illegal in 1961, abortion was made legal in 1973, and the major networks stopped censoring their TV programming in 1989. Since those watershed decisions, virtually every other valued institution has experienced significant erosion.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0050-04-6"
    }
  }, [_c('i', [_vm._v("Today, Christians in America are a minority. Christians are as much ")]), _c('i', [_vm._v("a minority, and their values and views are as impotent, as any minority ")]), _c('i', [_vm._v("group at any time in modern history.")]), _vm._v(" Why is this? Because we lead unexamined lives, many good men — Christian men — have been taken captive “through hollow and deceptive philosophy, which depends on human tradition and the elemental spiritual forces of this world.” In other words, many of us are Christians in our spirit but secular in our practice. We have become a generation of cultural Christians.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0050-05-8"
    }
  }, [_vm._v("We have seen things in bits and pieces instead of in totals. Archaeologists search the ruins of long-forgotten civilizations looking for, among other things, shards. A shard is a piece of broken pottery that the archaeologist studies. Then he visualizes what the object must have looked like by projecting from the broken pieces.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0050-06-10"
    }
  }, [_vm._v("This is how we should lead our lives. We should look at every shard — every idea and theory we discover flowing through our minds — and see which worldview it represents. Too often we see events and circumstances as unrelated and isolated when, instead, we should try to visualize how they fit into the bigger picture of our worldview.")])]), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0050-07-12"
    }
  }, [_c('a', {
    attrs: {
      "id": "page50"
    }
  }, [_vm._v("In his book "), _c('i', [_vm._v("The Closing of the American Mind")]), _vm._v(", Dr. Allan Bloom spoke to the issue of leading an unexamined life. He made a compelling case for replacing the openness of our times, what he termed “the openness of indifference,” with “the openness that invites us to the quest for knowledge and certitude.”")]), _c('span', {
    attrs: {
      "href": "#/chapter40#nts_6",
      "id": "not_6",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', [_vm._v("6")])])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0051-02-1"
    }
  }, [_c('a', {
    attrs: {
      "id": "page51"
    }
  }, [_vm._v("Dr. Bloom built the case that our society’s “openness” is not one that pursues the truth with dogged determination, but an openness that presses to be “open to all kinds of men, all kinds of lifestyles, all ideologies.” The only enemy is the man not open to everything.")])]), _c('a', {
    attrs: {
      "id": "page51"
    }
  }, [_c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0051-03-3"
    }
  }, [_vm._v("The man who thinks like this is so blind that he can’t tell you whether our daring circus rider is on horses or donkeys, nor could he tell you if one is better than the other — even if he were lucky enough to notice a difference.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0051-04-5"
    }
  }, [_vm._v("This is not openness that examines its beliefs in pursuit of moral truth and good, but openness that finds its virtue in saying yes to everything — anything goes. The Christian’s openness comes from his search for truth and absolutes. The secularist’s openness exists because he makes up the truth in his own “best thinking” and has no absolutes. He thinks it doesn’t matter what you believe, as long as you’re sincere.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0051-05-7"
    }
  }, [_vm._v("This captures one aspect of leading an unexamined life. We can know much, but if we do not use our knowledge to elevate ourselves — our mind, our soul, our spirit — to the highest level of moral good we can attain, then we are poor stewards of that knowledge. And we become Christians in captivity, held captive by the secular worldview, “captive through hollow and deceptive philosophy.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0051-06-10"
    }
  }, [_vm._v("If we are going to live by the Christian worldview, we must recognize, first, that ours is a minority view and, second, that we are responsible for our own lives. Christ aches for us to turn to Him and follow His plan. But we are the ones who must decide to do it. "), _c('i', [_vm._v("The ")]), _c('i', [_vm._v("first step to knowing God’s plan for our lives is the commitment to see ")]), _c('i', [_vm._v("ourselves as we really are.")])])]), _c('p', {
    staticClass: "h2",
    attrs: {
      "id": "p0052-01-0"
    }
  }, [_c('a', {
    attrs: {
      "id": "page51"
    }
  }), _c('a', {
    attrs: {
      "id": "page52"
    }
  }, [_vm._v("THE TWO YOUS ")])]), _c('a', {
    attrs: {
      "id": "page52"
    }
  }, [_c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "p0052-02-1"
    }
  }, [_vm._v("There are two yous — the "), _c('i', [_vm._v("visible ")]), _vm._v("you and the "), _c('i', [_vm._v("real")]), _vm._v(" you. The visible you is the you that is known by others. We know intuitively from our experiences how to act and speak to fit in with our peer groups. We often act differently from one peer group to the next.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0052-03-3"
    }
  }, [_vm._v("In high school, I was involved in three different peer groups. One was the jock crowd. When I worked out with the athletes, I talked tough and wouldn’t smoke or drink.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0052-04-5"
    }
  }, [_vm._v("Another peer group was the academics. I had been an honor student and liked these highbrows. We would discuss Darwinian theory and talk about the importance of science to the future of mankind. ")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0052-P-1"
    }
  }, [_vm._v("The third group was the hell-raisers. All weekend long I would smoke, drink beer, cruise the drive-in restaurants, and look for girls. Frankly, I was a nervous wreck around campus. When I walked the halls with one peer group, my eyes constantly darted around. I feared seeing a friend from a different peer group — then I would be exposed as an impostor!")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0052-05-8"
    }
  }, [_vm._v("Even though I portrayed three different people at school, a fourth Pat Morley showed up at home every day after school. I was a walking identity crisis!")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0052-06-10"
    }
  }, [_c('i', [_vm._v("The visible you is the known you.")]), _vm._v(" It is never the real you. We have learned to speak and act in ways that allow us to cope with our world and peacefully coexist. We work hard to project a certain image of ourselves to others.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0052-07-12"
    }
  }, [_c('i', [_vm._v("The real you is the you that is known by God")]), _vm._v(". We are who we are in our minds first, before we speak or act. Our speech and actions are the result of our thinking. Scripture tells us, “The heart is deceitful above all things and beyond cure. Who can understand it?” (Jeremiah 17:9). To protect our self-image, we kid, trick, and fool ourselves into believing the "), _c('i', [_vm._v("visible ")]), _vm._v("you is somehow "), _c('i', [_vm._v("real")]), _vm._v(". To see ourselves as we really are, we must acknowledge our inability to do so without God’s help.")])]), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0053-01-0"
    }
  }, [_c('a', {
    attrs: {
      "id": "page52"
    }
  }), _c('a', {
    attrs: {
      "id": "page53"
    }
  }, [_vm._v("The mind is where the battle takes place. It’s the battle between the majority view and the minority, Christian view. Ephesians 6:12 describes this battle for the mind: “For our struggle is not against flesh and blood, but against the rulers, against the authorities, against the powers of this dark world and against the spiritual forces of evil in the heavenly realms.”")])]), _c('a', {
    attrs: {
      "id": "page53"
    }
  }, [_c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0053-02-2"
    }
  }, [_vm._v("Because we don’t take this invisible war seriously, many of us are losing the battle for our minds. But we can win them back by committing ourselves to self-examination through studying the Scriptures. You can know the real you, the you that is known by our God. Let’s look at a promising tool to help us in the quest to understand ourselves.")]), _vm._v(" "), _c('p', {
    staticClass: "h2",
    attrs: {
      "id": "p0053-03-5"
    }
  }, [_vm._v("“LOOK AT THE FISH” ")]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "p0053-04-6"
    }
  }, [_vm._v("Ralph Waldo Emerson listed Louis Agassiz second in his journal of the men he most admired, after Carlyle and before the likes of Thoreau and Oliver Wendell Holmes. Agassiz had a magic touch with people. At a young age, he gained an international reputation as a natural scientist.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0053-05-8"
    }
  }, [_vm._v("Swiss born, he arrived in Boston in 1846 with boundless imagination and enthusiasm. He accepted a teaching post at Harvard University, where he conducted seemingly infinite investigations of fishes and fossils.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0053-06-10"
    }
  }, [_vm._v("As great as the genius of Agassiz was in the study of fossils and fishes, his genius as a teacher was of far greater significance. He trained a whole generation of scientific men who achieved important stature of their own. Agassiz developed his own original method of instruction, which gave his students an opportunity to learn to think for themselves and to work out their own problems.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0053-07-12"
    }
  }, [_vm._v("I first learned of Agassiz when I attended an executive education program at the Harvard Business School. The professors revere Agassiz and have immortalized him in the culture. His ideas on instruction are an integral part of the famous Harvard Business School case study method. The lesson for the man who would like to examine his life is considerable.")])]), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0054-02-2"
    }
  }, [_c('a', {
    attrs: {
      "id": "page53"
    }
  }), _c('a', {
    attrs: {
      "id": "page54"
    }
  }, [_vm._v("One of Agassiz’s students, who later became a professor of near equal popularity, Mr. Scudder, gave this account of Agassiz’s method:"), _c('br'), _c('br')])]), _c('a', {
    attrs: {
      "id": "page54"
    }
  }, [_c('p', {
    staticClass: "ext",
    attrs: {
      "id": "p0054-03-3"
    }
  }, [_vm._v("It was more than fifteen years ago [from 1874] that I entered the laboratory of Professor Agassiz . . . He asked me a few questions about my object in coming . . . “When do you wish to begin?” he asked.")]), _vm._v(" "), _c('p', {
    staticClass: "exta",
    attrs: {
      "id": "p0054-04-5"
    }
  }, [_vm._v("“Now,” I replied.")]), _vm._v(" "), _c('p', {
    staticClass: "exta",
    attrs: {
      "id": "p0054-05-7"
    }
  }, [_vm._v("This seemed to please him, and with an energetic “Very well!” he reached from a shelf a huge jar of specimen in yellow alcohol.")]), _vm._v(" "), _c('p', {
    staticClass: "exta",
    attrs: {
      "id": "p0054-06-9"
    }
  }, [_vm._v("“Take this fish,” said he, “and look at it . . . By and by I will ask what you have seen.” In ten minutes I had seen all that could be seen in that fish, and started in search of the Professor — who had, however, left the Museum . . . Half an hour passed — an hour — another hour; the fish began to look loathsome. I turned it over and around; looked it in the face — ghastly; from behind, beneath, above, sideways, at a three-quarters’ view — just as ghastly. I was in despair; at an early hour I concluded that lunch was necessary; so, with infinite relief, the fish was carefully replaced in the jar, and for an hour I was free.")]), _vm._v(" "), _c('p', {
    staticClass: "exta",
    attrs: {
      "id": "p0054-07-11"
    }
  }, [_vm._v("On my return, I learned that Professor Agassiz had been at the Museum, but had gone and would not return for several hours . . . Slowly I drew forth that hideous fish, and with a feeling of desperation again looked at it . . . I pushed my finger down its throat to feel how sharp the teeth were. I began to count the scales in the different rows, until I was convinced that that was nonsense. At last a happy thought struck me — I would draw the fish; and now with surprise I began to discover new features in the creature. Just then the Professor returned.")]), _vm._v(" "), _c('p', {
    staticClass: "exta",
    attrs: {
      "id": "p0054-08-14"
    }
  }, [_vm._v("“That is right,” said he: “A pencil is one of the best of eyes. Well, what is it like?”")]), _vm._v(" "), _c('p', {
    staticClass: "exta",
    attrs: {
      "id": "p0054-09-17"
    }
  }, [_vm._v("He listened attentively to my brief rehearsal . . .")]), _vm._v(" "), _c('p', {
    staticClass: "exta",
    attrs: {
      "id": "p0054-10-19"
    }
  }, [_vm._v("When I had finished, he waited as if expecting more, and then,  with an air of disappointment: “You have not looked very carefully . . . look again, look again!” And he left me to my misery . . .")])]), _c('p', {
    staticClass: "exta",
    attrs: {
      "id": "p0055-02-2"
    }
  }, [_c('a', {
    attrs: {
      "id": "page54"
    }
  }), _c('a', {
    attrs: {
      "id": "page55"
    }
  }, [_vm._v("I ventured to ask what I should do next.")])]), _c('a', {
    attrs: {
      "id": "page55"
    }
  }, [_c('p', {
    staticClass: "exta",
    attrs: {
      "id": "p0055-03-4"
    }
  }, [_vm._v("“Oh, look at your fish!” he said . . . And so for three long days he placed that fish before my eyes, forbidding me to look at anything else, or to use any artificial aid. “Look, look, look,” was his repeated injunction.")]), _vm._v(" "), _c('p', {
    staticClass: "exta",
    attrs: {
      "id": "p0055-04-6"
    }
  }, [_vm._v("This was the best entomological lesson I ever had — a lesson whose influence has extended to the details of every subsequent study; a legacy the Professor has left to me, as he has left it to many others, of inestimable value, which we could not buy, with which we cannot part . . .")]), _vm._v(" "), _c('p', {
    staticClass: "exta",
    attrs: {
      "id": "p0055-05-8"
    }
  }, [_vm._v("Agassiz’s training in the method of observing facts and their orderly arrangement was ever accompanied by the urgent exhortation not to be content with them.")]), _vm._v(" "), _c('p', {
    staticClass: "exta",
    attrs: {
      "id": "p0055-06-10"
    }
  }, [_vm._v("“Facts are stupid things,” he would say, “until brought into connection with some general law.”")])]), _c('p', {
    staticClass: "exta",
    attrs: {
      "id": "p0055-07-12"
    }
  }, [_c('a', {
    attrs: {
      "id": "page55"
    }
  }, [_vm._v("At the end of eight months, it was almost with reluctance that I left these friends and turned to insects; but what I had gained by this outside experience has been of greater value than years of later investigation in my favorite groups.")]), _c('span', {
    attrs: {
      "href": "#/chapter40#nts_7",
      "id": "not_7",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', [_vm._v("7")])]), _c('br'), _c('br')]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0055-08-13"
    }
  }, [_vm._v("The main reason we lead unexamined lives is that we do not take time to “look at the fish,” carefully looking for more and more. We can always see so much more, if we will only take the time to look. “Take this fish and look at it.” Soon we discover that Professor Agassiz’s criticism is just — we have not examined our lives carefully. With any good fortune we will soon be able to say, “No, I am certain I don’t see it yet, but I see how little I saw before.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0055-09-17"
    }
  }, [_vm._v("By the end of this book I hope it will be with Mr. Scudder’s reluctance that you leave this study and turn to some new area of self-examination. With the Bible as your resource book, you will be able to find God’s principle for every aspect of your life. You will be able to bring the bits and pieces of your life into connection with the general laws of God.")]), _vm._v(" "), _c('p', {
    staticClass: "h2",
    attrs: {
      "id": "p0056-01-0"
    }
  }, [_c('a', {
    attrs: {
      "id": "page56"
    }
  }, [_vm._v("CONCLUSION ")])]), _c('a', {
    attrs: {
      "id": "page56"
    }
  }, [_c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "p0056-02-1"
    }
  }, [_vm._v("Have you been leading an unexamined life? Have you ever understood the dramatic differences in worldviews? Do you understand why you think the things you think, say the things you say, and do the things you do?")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0056-03-3"
    }
  }, [_vm._v("Or, like Dempsey, have you been taking it one day at a time?")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0056-04-5"
    }
  }, [_vm._v("“Okay,” you say, “I’m convinced. I have decided there is more to know about the real me — the me that is known by God. What’s the next step?”")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0056-05-7"
    }
  }, [_vm._v("There was a pastor who wanted to get to know a church visitor who was a sports enthusiast. Since the pastor liked boxing, he invited the man to a boxing match, to which the man had never been. Just before the fight started, one of the boxers made the sign of the cross. ")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0056-P-1"
    }
  }, [_vm._v("“What does that mean?” asked the man.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0056-06-9"
    }
  }, [_vm._v("The pastor quickly replied, “It doesn’t mean a thing if the guy can’t box.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0056-07-11"
    }
  }, [_vm._v("Let’s move on, then, and gain the skills we need to win the battle for our minds. The rest of this book will provide you with a framework to think about specific problem areas of your life — a framework to look at the fish.")]), _vm._v(" "), _c('p', {
    staticClass: "h3",
    attrs: {
      "id": "p0056-08-13"
    }
  }, [_vm._v("FOCUS QUESTIONS ")]), _vm._v(" "), _c('p', {
    staticClass: "ol"
  }, [_vm._v("1. What would you like on your tombstone to summarize your life? ")]), _vm._v(" "), _c('p', {
    staticClass: "ol"
  }, [_vm._v("2. Which of your experiences and relationships do you think have had the greatest impact on how you think, speak, and act? In what ways have they influenced you for good? For bad? ")])]), _c('p', {
    staticClass: "ol"
  }, [_c('a', {
    attrs: {
      "id": "page56"
    }
  }, [_vm._v("3. Of the two worldviews, what percentage of each are you? Example: 60 percent Christian worldview, 40 percent ")]), _c('a', {
    attrs: {
      "id": "page57"
    }
  }, [_vm._v("secular worldview. Describe the thinking that led you to your answer.")])]), _c('a', {
    attrs: {
      "id": "page57"
    }
  }, [_c('p', {
    staticClass: "ol",
    attrs: {
      "id": "p0057-01-1"
    }
  }, [_vm._v("4. Are you the kind of person who gives thought to the "), _c('i', [_vm._v("why")]), _vm._v(" questions of life, or are you content with life as it is? What are some of the risks of leading an unexamined life?")]), _vm._v(" "), _c('p', {
    staticClass: "ol",
    attrs: {
      "id": "p0057-01-2"
    }
  }, [_vm._v("5. There are two yous – the "), _c('i', [_vm._v("visible")]), _vm._v(" you that is known by others and the "), _c('i', [_vm._v("real ")]), _vm._v("you that is known only by God.")]), _vm._v(" "), _c('p', {
    staticClass: "ols",
    attrs: {
      "id": "p0057-01-3"
    }
  }, [_c('span', {
    staticClass: "sp"
  }, [_c('img', {
    attrs: {
      "alt": "Ilf_9780310331759_conte_0043_006.jpg",
      "src": "images/Ilf_9780310331759_conte_0043_006.jpg"
    }
  })]), _vm._v(" Agree "), _c('span', {
    staticClass: "sp"
  }, [_c('img', {
    attrs: {
      "alt": "Ilf_9780310331759_conte_0043_006.jpg",
      "src": "images/Ilf_9780310331759_conte_0043_006.jpg"
    }
  })]), _vm._v(" Disagree. Explain your answer.")]), _vm._v(" "), _c('p', {
    staticClass: "ol",
    attrs: {
      "id": "p0057-01-4"
    }
  }, [_vm._v("6. Are you willing to allow God to show you yourself as you really are? What are some of the things you might find out about yourself?")]), _vm._v(" "), _c('p', {
    staticClass: "ol",
    attrs: {
      "id": "p0057-01-5"
    }
  }, [_vm._v("7. The secret of knowing something well is to keep “looking at the fish.” What kind of commitment would you be willing to make to self-examination in terms of time and effort?")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-cb563606","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/chapter8.vue
// module id = 87
// module chunks = 0